import React from 'react';

const ApplicationSvgFilters = () => (
    <svg width="0" height="0" viewBox="0 0 0 0" fill="none" xmlns="http://www.w3.org/2000/svg">
        <filter id="sharpBlur">
            <feGaussianBlur stdDeviation="7"/>
            <feColorMatrix
                values="1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 9 0"/>
            <feComposite in2="SourceGraphic" operator="in"/>
        </filter>
    </svg>
);

export default ApplicationSvgFilters;
